import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.y41_1 = operation;
        this.z41_1 = null;
        this.a42_1 = Companion_getInstance().p42_1;
        this.b42_1 = null;
        this.c42_1 = null;
        this.d42_1 = null;
        this.e42_1 = null;
        this.f42_1 = null;
        this.g42_1 = null;
        this.h42_1 = null;
        this.i42_1 = null;
        this.j42_1 = null;
        this.k42_1 = null;
        this.l42_1 = null;
        this.m42_1 = true;
        this.n42_1 = null;
        this.o42_1 = null;
      }
      q42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.z41_1 = requestUuid;
        return this;
      }
      r42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.a42_1 = executionContext;
        return this;
      }
      s42(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.j42_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      t42(url) {
        // Inline function 'kotlin.apply' call
        this.b42_1 = url;
        return this;
      }
      u42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.c42_1 = httpMethod;
        return this;
      }
      v42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.d42_1 = httpHeaders;
        return this;
      }
      w42(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.d42_1;
        tmp.d42_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      x42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.f42_1 = sendApqExtensions;
        return this;
      }
      y42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.g42_1 = sendDocument;
        return this;
      }
      z42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.e42_1 = enableAutoPersistedQueries;
        return this;
      }
      a43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.h42_1 = canBeBatched;
        return this;
      }
      b43(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.i42_1 = ignoreUnknownKeys;
        return this;
      }
      c43(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.k42_1 = retryOnError;
        return this;
      }
      d43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.l42_1 = failFastIfOffline;
        return this;
      }
      e43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.m42_1 = sendEnhancedClientAwareness;
        return this;
      }
      f43(extensions) {
        // Inline function 'kotlin.apply' call
        this.n42_1 = extensions;
        return this;
      }
      v39() {
        var tmp1_operation = this.y41_1;
        var tmp0_elvis_lhs = this.z41_1;
        var tmp2_requestUuid = tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs;
        var tmp3_executionContext = this.a42_1;
        var tmp4_httpMethod = this.c42_1;
        var tmp5_httpHeaders = this.d42_1;
        var tmp6_sendApqExtensions = this.f42_1;
        var tmp7_sendDocument = this.g42_1;
        var tmp8_enableAutoPersistedQueries = this.e42_1;
        var tmp9_canBeBatched = this.h42_1;
        var tmp10_ignoreApolloClientHttpHeaders = this.j42_1;
        var tmp11_retryOnError = this.k42_1;
        var tmp12_failFastIfOffline = this.l42_1;
        var tmp13_ignoreUnknownKeys = this.i42_1;
        var tmp14_sendEnhancedClientAwareness = this.m42_1;
        var tmp15_url = this.b42_1;
        var tmp16_extensions = this.n42_1;
        var tmp17_onError = this.o42_1;
        return new (ApolloRequest())(tmp1_operation, tmp2_requestUuid, tmp16_extensions, tmp17_onError, tmp3_executionContext, tmp15_url, tmp4_httpMethod, tmp5_httpHeaders, tmp6_sendApqExtensions, tmp7_sendDocument, tmp8_enableAutoPersistedQueries, tmp9_canBeBatched, tmp13_ignoreUnknownKeys, tmp10_ignoreApolloClientHttpHeaders, tmp11_retryOnError, tmp12_failFastIfOffline, tmp14_sendEnhancedClientAwareness);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, extensions, onError, executionContext, url, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreUnknownKeys, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.g43_1 = operation;
        this.h43_1 = requestUuid;
        this.i43_1 = extensions;
        this.j43_1 = onError;
        this.k43_1 = executionContext;
        this.l43_1 = url;
        this.m43_1 = httpMethod;
        this.n43_1 = httpHeaders;
        this.o43_1 = sendApqExtensions;
        this.p43_1 = sendDocument;
        this.q43_1 = enableAutoPersistedQueries;
        this.r43_1 = canBeBatched;
        this.s43_1 = ignoreUnknownKeys;
        this.t43_1 = ignoreApolloClientHttpHeaders;
        this.u43_1 = retryOnError;
        this.v43_1 = failFastIfOffline;
        this.w43_1 = sendEnhancedClientAwareness;
      }
      x43() {
        return this.y43(this.g43_1);
      }
      y43(operation) {
        return (new (Builder())(operation)).q42(this.h43_1).r42(this.k43_1).t42(this.l43_1).u42(this.m43_1).v42(this.n43_1).x42(this.o43_1).y42(this.p43_1).z42(this.q43_1).a43(this.r43_1).c43(this.u43_1).d43(this.v43_1).s42(this.t43_1).b43(this.s43_1).e43(this.w43_1).f43(this.i43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
